import { GET_QUIZES } from "../../shared/constants/ActionTypes";

const initialBooks = {
  quizes: [],
  page: 1,
  total: 0,
};

function quizReducer(state = initialBooks, action) {
  switch (action.type) {
    case GET_QUIZES:
      return {
        ...state,
        quizes: action.payload.data.data,
        total: action.payload.data.total,
      };
    default:
      return state;
  }
}

export default quizReducer;
